import { Suspense } from 'react';

export const DynamicComponent = ({ component, props = {} }) => {
  if (typeof component === 'function') {
    return component(props);
  } else if (typeof component === 'object') {
    const ComponentToRender = component;
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <ComponentToRender {...props} />
      </Suspense>
    );
  } else return component;
};
